import {useEffect, useMemo} from 'react';
import {useMarketersStore} from '../../marketers/store/marketersStore';
import {useMarketerTrackingStore} from '../store/marketerTrackingStore';

/**
 * Orchestrates the Marketer Tracking page:
 *  - Ensures the marketers list is loaded (for the selector)
 *  - Exposes current selection + map data from the tracking store
 *  - Handlers that components bind to directly
 */
export const useMarketerTrackingManagement = () => {
  const marketersStore = useMarketersStore();
  const trackingStore = useMarketerTrackingStore();

  useEffect(() => {
    if (marketersStore.marketers.length === 0 && !marketersStore.loading) {
      // Load ALL marketers (limit=all) so the selector isn't capped at one page.
      marketersStore.fetchAllMarketers();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- mount-only
  }, []);

  const marketerOptions = useMemo(
    () =>
      marketersStore.marketers.map((m) => ({
        id: Number((m as {id: number | string}).id),
        name:
          (m as {full_name?: string; fullName?: string; name?: string}).full_name ||
          (m as {full_name?: string; fullName?: string; name?: string}).fullName ||
          (m as {full_name?: string; fullName?: string; name?: string}).name ||
          `#${(m as {id: number}).id}`,
        // username included so the tracking-page selector can be searched by
        // username as well as by name.
        username: (m as {username?: string}).username
      })),
    [marketersStore.marketers]
  );

  return {
    // Selector state
    marketerOptions,
    loadingMarketers: marketersStore.loading,
    selectedMarketerId: trackingStore.selectedMarketerId,
    selectedDate: trackingStore.selectedDate,
    setSelectedMarketer: trackingStore.setSelectedMarketer,
    setSelectedDate: trackingStore.setSelectedDate,

    // Day view
    selectedSession: trackingStore.selectedSession,
    selectedTrack: trackingStore.selectedTrack,
    loadingSelected: trackingStore.loadingSelected,
    selectedError: trackingStore.selectedError,

    // History
    history: trackingStore.history,
    loadingHistory: trackingStore.loadingHistory,
    historyError: trackingStore.historyError
  };
};
